const paymentMethodsDE = {
    "view": {
        "table": {
            "title": "Ihre Zahlungsmethodenliste",
            "column": {
                "cardholder_name": "Karteninhaber Name",
                "card_number": "Kartennummer",
                "expiry_month": "Ablaufmonat",
                "expiry_year": "Ablaufjahr",
                "type": "Typ",
                "status": "Status",
                "action": "Aktion"
            },
            "label": {
                "is_default": "Standard",
                "is_secondary": "Sekundär",
                "is_valid": "Gültig",
                "is_expired": "Abgelaufen",
                "not_available": "Nicht verfügbar",
                "month_january": "Januar",
                "month_february": "Februar",
                "month_march": "März",
                "month_april": "April",
                "month_may": "Mai",
                "month_june": "Juni",
                "month_july": "Juli",
                "month_august": "August",
                "month_september": "September",
                "month_october": "Oktober",
                "month_november": "November",
                "month_december": "Dezember"
            },
            "dropdown": {
                "action": "Aktion",
                "edit": "Bearbeiten",
                "delete": "Löschen"
            }
        },
        "message": {
            "maxPaymentMethodsLimitReached": "Sie haben das Limit von 3 Zahlungsmethoden erreicht. Wenn Sie eine neue Zahlung hinzufügen möchten, können Sie dies tun, indem Sie eine bestehende löschen.",
            "success": "Zahlungsmethode wurde entfernt!",
            "error": "Etwas ist schief gelaufen! Bitte Seite aktualisieren und erneut versuchen!"
        },
        "modal": {
            "delete": {
                "header": "Zahlungsmethode {{cardNumber}} löschen",
                "body": "Sind Sie sicher, dass Sie diese Zahlungsmethode löschen möchten?"
            }
        }
    },
    "add": {
        "title": "Zahlungsmethode hinzufügen",
        "form": {
            "label": {
                "card_details": "Kartendetails",
                "cardholder_name": "Karteninhaber Name",
                "card_number": "Kartennummer",
                "expiry_month": "Ablaufmonat",
                "expiry_year": "Ablaufjahr (JJJJ)",
                "security_code_cvc": "Sicherheitscode (CVC)",
                "billing_details": "Rechnungsdetails",
                "country": "Land",
                "street_and_number": "Straße und Hausnummer",
                "city": "Stadt",
                "postal_code": "Postleitzahl"
            },
            "help_text": {
                "security_code_cvc": "Der Sicherheitscode (CVC) Ihrer Karte ist die 3- oder 4-stellige Nummer auf der Rückseite der meisten Karten."
            },
            "options": {
                "month": {
                    "january": "Januar",
                    "february": "Februar",
                    "march": "März",
                    "april": "April",
                    "may": "Mai",
                    "june": "Juni",
                    "july": "Juli",
                    "august": "August",
                    "september": "September",
                    "october": "Oktober",
                    "november": "November",
                    "december": "Dezember"
                },
                "expiry_month": {
                    "select": "Ablaufmonat auswählen"
                },
                "country": {
                    "select": "Land auswählen"
                }
            },
            "button": {
                "submit": "Einreichen"
            },
            "validation": {
                "expiry_month_required": "Ablaufmonat ist erforderlich",
                "expiry_month_valid": "Ablaufmonat darf nicht in der Vergangenheit liegen",
                "country_required": "Land ist erforderlich"
            }
        },
        "message": {
            "success": "Zahlungsmethode wurde hinzugefügt!",
            "error": "Etwas ist schief gelaufen! Bitte Seite aktualisieren und erneut versuchen!"
        },
        "modal": {
            "addPaymentMethod": {
                "header": "Sind Sie sicher, dass Sie diese Zahlungsmethode zu Ihrem Profil hinzufügen möchten?",
                "body": "Hiermit versichern Sie, dass alle angegebenen Daten wahrheitsgemäß sind. Sie sind allein und rechtlich verantwortlich für die angegebenen Daten und die Richtigkeit dieser Informationen.",
                "button": {
                    "cancel": "Abbrechen",
                    "confirm": "Bestätigen"
                }
            }
        }
    },
    "update": {
        "title": "Zahlungsmethode aktualisieren",
        "form": {
            "label": {
                "card_details": "Kartendetails",
                "cardholder_name": "Karteninhaber Name",
                "card_number": "Kartennummer",
                "expiry_month": "Ablaufmonat",
                "expiry_year": "Ablaufjahr (JJJJ)",
                "security_code_cvc": "Sicherheitscode (CVC)",
                "billing_details": "Rechnungsdetails",
                "country": "Land",
                "street_and_number": "Straße und Hausnummer",
                "city": "Stadt",
                "postal_code": "Postleitzahl",
                "set_as_default": "Als Standard festlegen"
            },
            "help_text": {
                "security_code_cvc": "Der Sicherheitscode (CVC) Ihrer Karte ist die 3- oder 4-stellige Nummer auf der Rückseite der meisten Karten."
            },
            "options": {
                "month": {
                    "january": "Januar",
                    "february": "Februar",
                    "march": "März",
                    "april": "April",
                    "may": "Mai",
                    "june": "Juni",
                    "july": "Juli",
                    "august": "August",
                    "september": "September",
                    "october": "Oktober",
                    "november": "November",
                    "december": "Dezember"
                },
                "expiry_month": {
                    "select": "Ablaufmonat auswählen"
                },
                "country": {
                    "select": "Land auswählen"
                }
            },
            "button": {
                "submit": "Einreichen"
            },
            "validation": {
                "expiry_month_required": "Ablaufmonat ist erforderlich",
                "expiry_month_valid": "Ablaufmonat darf nicht in der Vergangenheit liegen",
                "country_required": "Land ist erforderlich"
            }
        },
        "message": {
            "success": "Zahlungsmethode wurde aktualisiert!",
            "error": "Etwas ist schief gelaufen! Bitte Seite aktualisieren und erneut versuchen!"
        },
        "modal": {
            "updatePaymentMethod": {
                "header": "Sind Sie sicher, dass Sie Ihre Zahlungsmethode aktualisieren möchten?",
                "body": "Hiermit versichern Sie, dass alle angegebenen Daten wahrheitsgemäß sind. Sie sind allein und rechtlich verantwortlich für die angegebenen Daten und die Richtigkeit dieser Informationen.",
                "button": {
                    "cancel": "Abbrechen",
                    "confirm": "Bestätigen"
                }
            }
        }
    }
};

export default paymentMethodsDE;